import Widget from "csi/html/Widget";
import declare from "dojo/_base/declare";

const PCAPropertiesController = declare(Widget, {
	/**
	 * @override
	 * Hide the Properties view title bar
	 */
	_processKey(ctx, key, def, domNode) {
		if (key === "1") {
			ctx.defView.bShowLabels = false;
		} else {
			ctx.defView.bShowLabels = true;
		}

		return this.inherited(arguments);
	},
});

export = PCAPropertiesController;